module.exports = __webpack_public_path__ + "img/joy_05.ea8cb4f6.png";